import React, { useState } from "react";
import { Box, Button, TextField, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

const CreateChoice = ({ disableParent = false, onCreateChoice }) => {
  const [choice, setChoice] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [error, setError] = useState("");

  const validate = () => {
    if (!choice) {
      setError("必須事項です");
      return false;
    }
    if (choice.length > 100) {
      setError("100字以内で入力してください");
      return false;
    }
    setError("");
    return true;
  };

  const addChoice = () => {
    if (!validate()) {
      return;
    }
    setDisabled(true);
    setShowAddBtn(false);
    if (onCreateChoice) {
      onCreateChoice(choice);
    }
  };

  return (
    <Box ml={3} component="form">
      <Box display="flex" alignItems="center">
        <TextField
          label="選択肢"
          value={choice}
          onChange={(e) => setChoice(e.target.value)}
          disabled={disabled}
          error={!!error}
          helperText={error}
          inputProps={{ maxLength: 100 }}
          fullWidth
        />
        {showAddBtn && !disableParent && (
          <IconButton
            onClick={addChoice}
            color="primary"
            disabled={disabled}
            size="large"
          >
            <AddIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default CreateChoice;